var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentStatusWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.447 2.012l6.382 12.764a.5.5 0 01-.447.724H1.618a.5.5 0 01-.447-.724L7.553 2.012a.5.5 0 01.894 0z",
    fill: "#EE7E0F",
    fillOpacity: 0.1,
    stroke: "#EE7E0F",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.6h2l-.5 4h-1l-.5-4z",
    fill: "#EE7E0F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12.4,
    r: 1,
    fill: "#EE7E0F"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNDQ3MjEgMi4wMTI0NkwxNC44MjkyIDE0Ljc3NjRDMTQuOTk1NCAxNS4xMDg4IDE0Ljc1MzcgMTUuNSAxNC4zODIgMTUuNUgxLjYxODAzQzEuMjQ2MzQgMTUuNSAxLjAwNDYgMTUuMTA4OCAxLjE3MDgyIDE0Ljc3NjRMNy41NTI3OSAyLjAxMjQ2QzcuNzM3MDUgMS42NDM5NCA4LjI2Mjk1IDEuNjQzOTQgOC40NDcyMSAyLjAxMjQ2WiIgZmlsbD0iI0VFN0UwRiIgZmlsbC1vcGFjaXR5PSIwLjEiIHN0cm9rZT0iI0VFN0UwRiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNyA2LjZIOUw4LjUgMTAuNkg3LjVMNyA2LjZaIiBmaWxsPSIjRUU3RTBGIi8+CjxjaXJjbGUgY3g9IjgiIGN5PSIxMi40IiByPSIxIiBmaWxsPSIjRUU3RTBGIi8+Cjwvc3ZnPgo=";
export { SvgAgentStatusWarning as ReactComponent };